export { SectionLabel } from "./SectionLabel"
export type { SectionLabelProps } from "./SectionLabel"
